import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class DepositLimitCalculatorConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getDepositLimitCalculatorEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.depositLimitCalculator,
			"v1/depositableamount/prediction"
		);
	}
}
